var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-price",attrs:{"flex":"cross:bottom"}},[_c('span',{staticClass:"rmb"},[_vm._v("￥")]),_vm._v(" "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm.showPrice[0]))]),_vm._v(" "),_c('span',{staticClass:"small-price"},[_vm._v("."+_vm._s(_vm.showPrice[1]))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e179050","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CPrice.vue
// module id = null
// module chunks = 